import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DetailImageAndLabel from 'components/DetailImageAndLabel';
import ResourcePageHighlights from 'components/ResourcePageHighlights';
import ResourceName from 'components/ResourceName';
import ResourceType from 'components/ResourceType';
import Hidden from '@material-ui/core/Hidden';
import ItemPageScoring from 'components/ItemPageScoring';
import MobileTaggedTopics from 'components/ResourcePageLeftPanel/MobileTaggedTopics';
import MobileActionsPanel from 'components/ResourcePageLeftPanel/MobileActionsPanel';
import PaddedGrid from 'components/PaddedGrid';
import TextValue from 'components/TextValue';
import useSiteCopySelector from 'components/useSiteCopySelector';
import ResourceImageAndInfoLayout from 'components/ResourceImageAndInfoLayout';
import ServiceLinks from './ServiceLinks';

const useStyles = makeStyles(theme => ({
  titleWithIcon: {
    display: 'flex',
  },
  root: {
    position: 'relative',
  },
  typeWrapper: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: 18,
    },
  },
}));

function ServiceInformation({ data, leftPanelData, hasUserReviews }) {
  const classes = useStyles();
  const [resourceItemPageSiteCopy] = useSiteCopySelector([
    'resource-item-page',
  ]);

  if (_isEmpty(data)) return null;
  const {
    sys: { contentType },
    fields: {
      name,
      subtitle,
      audienceType = [],
      highlights = [],
      tags = [],
      costDescription = '',
    },
    fields,
  } = data.items[0];

  const imageNode = (
    <DetailImageAndLabel
      data={fields}
      type={contentType.sys.id}
      render={() => <ServiceLinks data={data.items} />}
      withLinks
    />
  );
  const mobileNode = (
    <Hidden mdUp>
      <MobileTaggedTopics data={_get(leftPanelData, 'acceptedTopics')} />
    </Hidden>
  );

  const infoNode = (
    <>
      <PaddedGrid item xs={12}>
        <div className={classes.typeWrapper}>
          <ResourceType
            type={_get(resourceItemPageSiteCopy, [
              'pageCopy',
              'resourceTypeMapping',
              'SERVICES',
            ])}
          />
        </div>
      </PaddedGrid>
      <PaddedGrid item xs={12}>
        <ResourceName name={name} />
      </PaddedGrid>
      {!_isEmpty(subtitle) && (
        <PaddedGrid item xs={12}>
          <Typography color="textPrimary" variant="body2">
            {subtitle}
          </Typography>
        </PaddedGrid>
      )}
      <Hidden mdUp>
        <MobileActionsPanel data={leftPanelData} />
      </Hidden>
      <ResourcePageHighlights
        audience={audienceType}
        highlights={highlights}
        tags={tags}
      />
      <ItemPageScoring
        data={data.items}
        type="service"
        hasUserLink={hasUserReviews}
      />
      {costDescription && (
        <PaddedGrid item xs={12}>
          <TextValue
            label={_get(resourceItemPageSiteCopy, 'pageCopy.costLabel')}
            value={costDescription}
          />
        </PaddedGrid>
      )}
    </>
  );

  return (
    <ResourceImageAndInfoLayout
      image={imageNode}
      mobile={mobileNode}
      info={infoNode}
    />
  );
}

ServiceInformation.propTypes = {
  data: PropTypes.array,
  leftPanelData: PropTypes.object,
  hasUserReviews: PropTypes.bool,
};

export default ServiceInformation;
